import dayjs from 'dayjs'
import tz from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import duration from 'dayjs/plugin/duration'

import 'dayjs/locale/ru'
import 'dayjs/locale/lt'
import 'dayjs/locale/lv'
import 'dayjs/locale/et'
import 'dayjs/locale/ka'

dayjs.extend(utc)
dayjs.extend(tz)
dayjs.extend(duration)

dayjs.tz.setDefault('Europe/Riga')

const hasTimezone = /([+-]\d{2}:\d{2}|Z)$/

const timezonedDayjs = (...args) => {
  if (args.length) {
    if (typeof args[0] === 'string') {
      if (hasTimezone.test(args[0])) {
        return dayjs(args[0]).tz('Europe/Riga')
      }
      return dayjs.tz(args[0], 'Europe/Riga')
    }
    return dayjs(...args)
  }
  return dayjs().tz()
}

const timezonedUnix = (value) => {
  return dayjs.unix(value)
  // return dayjs.unix(value).tz()
}

timezonedDayjs.unix = timezonedUnix
timezonedDayjs.duration = dayjs.duration
timezonedDayjs.utc = dayjs.utc

export default timezonedDayjs
